import { useWindowWidth } from "@react-hook/window-size";
import { serverFetch } from "@src/server";
import { userLoaded } from "@src/store/actions";
import { useAppDispatch } from "@src/store/hooks";
import { Button, Form, Input, message } from "antd";
import { MaskedInput } from "antd-mask-input";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import jwt_decode from 'jwt-decode';
import { authvk, setAccessToken } from "@src/extensions/auth-vk";
import { getIsVkSession, getVkSession } from "@src/extensions/utils";
import "./booking-form.css";
import { Spinner } from "@src/controls";

const BookingForm = ({...props}) => {
  const { orderData, setOrderData, readyToBook, onBook } = props;
  const [form] = Form.useForm();
  const isMobile: boolean = useWindowWidth() <= 1130;
  const user = useSelector((s:any) => s.user);
  const d = useAppDispatch();
  const [logining, setLogining] = useState(false);

  const onValuesChange = (a: any) => setOrderData({ ...orderData, ...a });

  const onLogout = () => serverFetch('auth/logout', {method: 'POST'})
        .then(() => d(userLoaded(undefined)))
        .catch(() => d(userLoaded(undefined)));

  const onSendCode = async () => {
    const email = form.getFieldValue("email");
    serverFetch(`Auth/GenerateCheckcode`, {method: 'POST', bodyData: { email }})
        .then(() => setOrderData({...orderData, codeSent: true }))
        .catch(e => message.error(`Ошибка отправки кода ${e.userMessage || ''} `));
  };

  useEffect(() => form.setFieldsValue(orderData), [form, orderData]);
  //console.log(orderData)
  const onCheckCode = async () => {
    const email = form.getFieldValue("email");
    serverFetch(`Auth/signin`, {method: 'POST', bodyData: { email, checkcode: orderData.code } })
        .then((data) => {
            localStorage.setItem('refreshToken', data.refreshToken);
            var result:any = jwt_decode(data.accessToken);
            let session = {
                userId: result.userId,
                touristName: result.touristName,
                touristSurname: result.touristSurname,
                touristPatronymic: result.touristPatronymic,
                email: result.email,
                touristPhone: result.touristPhone,
            };
            d(userLoaded(session));
            const element = document.getElementById('booking-order-btn-book');
            if (element) element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        })
        .catch(() => message.error(`Неверный код`));
  };

    const isVkSession = getIsVkSession();

    const startR = (state:any) => {
        //console.log(state);
        const interval = setInterval(() => {
            serverFetch(`vk/session?state=${state}`)
                .then((data) => {
                    if (data){
                        console.log(data);
                        clearInterval(interval);
                        setAccessToken(data.accessToken);
                        //window.accessToken = data.accessToken;
                        
                        var result:any = jwt_decode(data.accessToken);
                        localStorage.setItem('refreshToken', data.refreshToken);
                        if (!result.email) {
                          message.error("К данной учетной записи не привязана почта. Выберите другую запись или привяжите почту");
                          setLogining(false);
                        }
                        else {
                          console.log(result);
                          let session = {
                              userId: result.userId,
                              touristName: result.touristName,
                              touristSurname: result.touristSurname,
                              touristPatronymic: result.touristPatronymic,
                              email: result.email,
                              touristPhone: result.touristPhone,
                          };
                          d(userLoaded(session));
                          setLogining(false);
                          const element = document.getElementById('booking-order-btn-book');
                          if (element) element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        }
                        //onClose();
                    }
                })
                .catch(e => {
                    console.log(e);
                    clearInterval(interval);
                });
          }, 1000); // Интервал 1 секунда (1000 миллисекунд)
        //setIntervaled(interval)
    }

    const startVkLogin = (provider:any) => {
        if (provider !== "vkid" && isVkSession) return;
        setLogining(true);
        if (isVkSession) {
          const bodyData = JSON.parse(atob(getVkSession() as string));
          serverFetch(`vk/sign`, { method: 'POST', bodyData })
            .then(data => {
              setLogining(false);
              d(userLoaded(data));
            })
            .catch(e => {
              console.log(e.userMessage);
              setLogining(false);
              message.error('Ошибка входа. Попробуйте перегрузить страницу и предоставить доступ приложению до данных почты и телефона');
            });
        }
        else {
          authvk(provider, startR);
        }
    }


  return logining ? <div className="auth-spinner"><Spinner /></div> : <Form size={'large'} form={form}
    initialValues={{ email: '', code: '', codeSent: false, emailChecked: false, firstName: '', secondName: '', lastName: '', phone: '',}}
    labelCol={{ span: isMobile ? 6 : 4 }} wrapperCol={{ span: isMobile ? 18 : 6 }} layout='horizontal' colon={false}
    onValuesChange={onValuesChange}>

    {orderData.emailChecked || <Form.Item label=" ">
      <div className='booking-form-auth-icons'>
        <img src='/images/vk.svg' alt='vk' onClick={() => startVkLogin("vkid")}/>
        <img src='/images/ok.svg' alt='ok' onClick={() => startVkLogin("ok_ru")}/>
        <img src='/images/mail.svg' alt='mail' onClick={() => startVkLogin("mail_ru")}/>
      </div>
    </Form.Item>}

    <Form.Item label='Ваша почта' name='email'><Input placeholder='Введите адрес электронной почты' disabled={orderData.emailChecked} /></Form.Item>
    {orderData.emailChecked && <Form.Item label=' '><Button onClick={onLogout}>Очистить</Button></Form.Item>}
    {!orderData.emailChecked && <Form.Item wrapperCol={{ offset: 4 }}>
      <Button className='action-button' onClick={onSendCode} disabled={orderData.emailChecked}>ОТПРАВИТЬ КОД НА ПОЧТУ</Button>
      {orderData.codeSent && <div>Код отправлен на почту</div>}
      <div style={{fontSize: 12, color: 'gray', marginTop: 4}}>
        <span>Нажимая кнопку Отправить код на почту и Забронировать, Вы соглашаетесь c </span>
        <Link to={`/article/${encodeURIComponent("https://kb.rr-tour.ru/article/2169")}`} target="_blank"><strong>Условиями и правилами</strong></Link>
        <span> и </span>
        <Link to={`/article/${encodeURIComponent("https://kb.rr-tour.ru/article/2170")}`} target="_blank"><strong>Политикой конфиденциальности</strong></Link>.
      </div>
    </Form.Item>}
    {orderData.codeSent && <>
      <Form.Item label='Введите код' name='code'><Input disabled={orderData.emailChecked} placeholder='Введите код из почты' /></Form.Item>
      <Form.Item wrapperCol={{ offset: 4 }}>
        <Button className='action-button' disabled={!orderData.codeSent || orderData.emailChecked} onClick={onCheckCode}>ПРОВЕРИТЬ КОД</Button>
      </Form.Item>
    </>}
    {orderData.emailChecked && <>
      <Form.Item wrapperCol={{ offset: 4 }}><div>Ваши данные</div></Form.Item>
      <Form.Item label='Фамилия' name='secondName'><Input disabled={user && user.touristSurname} /></Form.Item>
      <Form.Item label='Имя' name='firstName'><Input disabled={user && user.touristName} /></Form.Item>
      <Form.Item label='Отчество' name='lastName'><Input disabled={user && user.touristPatronymic} /></Form.Item>
      <Form.Item label='Телефон' name='phone'><MaskedInput mask='+{7}0000000000' disabled={user && user.touristPhone && user.touristPhone !== "+7__________"}/></Form.Item>
    </>}
    <Form.Item wrapperCol={{ offset: 4 }}><div>Общая стоимость {orderData.price.toLocaleString('ru-RU')} ₽</div></Form.Item>
    <Form.Item wrapperCol={{ offset: 4 }}>
      <Button className='action-button' disabled={!readyToBook} onClick={onBook} id='booking-order-btn-book'>ЗАБРОНИРОВАТЬ</Button>
    </Form.Item>
  </Form>
}

export default BookingForm;